import React from "react";
import "./style.css";
import siteUrl from "./../../siteUrl";
import imageUrl from "../../imageUrl";

const CardHomeItem = (props) => {
  const { data } = props;
  return (
      <a className="card-home-zone" href={`${siteUrl}#${data.url}`}>
    {/*<a
      className="card-home-zone"
      href={`${
        siteUrl != "https://ap-vr.com" ? siteUrl.replace("/index.html", "") : ""
      }/single-detached-house/${data.url}${siteUrl != "https://ap-vr.com" ? "/index.html" : ""}`}
    >
    */}
      <div className="img">
        <div className="card-overlay"></div>
        <img src={`${imageUrl}${data.image[0]}`} alt={data.name} />
      </div>
      <div className="card-detail">
        <div className="home-name">{data.name}</div>
        <div className="home-price">{data.price}</div>
        <div className="home-headline">{data.headline}</div>
      </div>
    </a>
  );
};
export default CardHomeItem;
